import { useMutation } from '@tanstack/react-query';
import type { CandidateProfileChatCommentsRequest } from '../types/CandidateProfile';

export default function usePostCandidateChatComments() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId, body }: CandidateProfileChatCommentsRequest) => {
      const response = await fetch(
        `/agent/api/candidate_profiles/${candidateProfileId}/candidate_chat_comments`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token,
          },
          body: JSON.stringify({ body }),
        }
      );
      const data = await response.json();
      return data;
    },
  });
}
